/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ISuggestedChangeReviewMutationVariables = Types.Exact<{
  suggestedChangeId: Types.Scalars['ID']['input'];
  verdict: Types.SuggestedChangeVerdictEnum;
}>;

export type ISuggestedChangeReviewMutation = {
  __typename?: 'Mutation';
  suggestedChangeReview?: {
    __typename?: 'SuggestedChangeReviewPayload';
    success: boolean;
    errors?: Array<string> | null;
  } | null;
};

export const SuggestedChangeReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'suggestedChangeReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'suggestedChangeId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'verdict' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SuggestedChangeVerdictEnum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suggestedChangeReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'suggestedChangeId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'suggestedChangeId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'verdict' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'verdict' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ISuggestedChangeReviewMutation, ISuggestedChangeReviewMutationVariables>;
